import { STATE_KEY } from 'src/utils/consts'
import { getLocalStore } from 'src/utils'

export const initialState = {
  windowWidth: 10000,
  shouldShowMobileCategory: false,
  shouldScroll: false,
}

export const loadState = () => {
  try {
    return getLocalStore(STATE_KEY) || {}
  } catch (err) {
    return {}
  }
}

export default initialState
